import history from 'utils/history';

export const inTrolleyPage = () => history.getLocation().pathname.includes('/shop/trolley');
